import { render, staticRenderFns } from "./salesAnalytics.vue?vue&type=template&id=a6c70fdc&"
import script from "./salesAnalytics.vue?vue&type=script&lang=js&"
export * from "./salesAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports